import React from "react";

const Patient_amount_view = () => {
    return (
        <div className='card rounded-4	h-100 '>
            <div className='card-header rounded-4'>
                <div className='d-flex align-items-center flex-wrap gap-2 justify-content-center'>
                    <h6 className='mb-2 fw-bold text-lg mb-0'>Investment</h6>
                </div>
            </div>
            <div className='card-body py-24'>
                {/* <p className='text-center text-secondary-light d-flex align-items-center gap-8 justify-content-center'>
                    Total Investment:{" "}
                    <span className='fw-semibold text-primary-light'>$500</span>{" "}
                </p> */}
                <div className='mt-40 mb-24 text-center pe-110 position-relative max-w-288-px mx-auto'>
                    <div className='w-170-px h-170-px rounded-circle z-1 position-relative d-inline-flex justify-content-center align-items-center border border-white border-width-2-px'>
                        <img
                            src='assets/images/home-eleven/bg/radial-bg1.png'
                            alt=''
                            className='position-absolute top-0 start-0 z-n1 w-100 h-100 object-fit-cover'
                        />
                        <h5 className='text-white'> 60% </h5>
                    </div>
                    <div className='w-144-px h-144-px rounded-circle z-1 position-relative d-inline-flex justify-content-center align-items-center border border-white border-width-3-px position-absolute top-0 end-0 mt--36'>
                        <img
                            src='assets/images/home-eleven/bg/radial-bg2.png'
                            alt=''
                            className='position-absolute top-0 start-0 z-n1 w-100 h-100 object-fit-cover'
                        />
                        <h5 className='text-white'> 30% </h5>
                    </div>
                    <div className='w-110-px h-110-px rounded-circle z-1 position-relative d-inline-flex justify-content-center align-items-center border border-white border-width-3-px position-absolute bottom-0 start-50 translate-middle-x ms-48'>
                        <img
                            src='assets/images/home-eleven/bg/radial-bg3.png'
                            alt=''
                            className='position-absolute top-0 start-0 z-n1 w-100 h-100 object-fit-cover'
                        />
                        <h5 className='text-white'> 10% </h5>
                    </div>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                    <div className='d-flex flex-column align-items-center'>
                        <div className='d-flex align-items-center gap-2'>
                            <span className='w-12-px h-12-px rounded-pill bg-primary-600' />
                            <span className='text-secondary-light text-sm fw-normal'>
                                Valid Amount
                            </span>
                        </div>
                        <h6 className='fw-semibold mb-0 mt-4 text-lg color_bubble_blue'>
                            $50,000
                        </h6>
                    </div>
                    <div className='d-flex flex-column align-items-center'>
                        <div className='d-flex align-items-center gap-2'>
                            <span className='w-12-px h-12-px rounded-pill bg-purple' />
                            <span className='text-secondary-light text-sm fw-normal '>
                                Due Amount
                            </span>
                        </div>
                        <h6 className='fw-semibold mb-0 mt-4 text-lg color_bubble_violet'>
                            $150
                        </h6>
                    </div>
                    <div className='d-flex flex-column align-items-center'>
                        <div className='d-flex align-items-center gap-2'>
                            <span className='w-12-px h-12-px rounded-pill bg-success-600' />
                            <span className='text-secondary-light text-sm fw-normal'>
                                Total Amount
                            </span>
                        </div>
                        <h6 className='fw-semibold mb-0 mt-4 text-lg color_bubble_green'>
                            $100
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Patient_amount_view;
